/**
 * Created by 丸子 on 2018/7/29 0029.
 */
export const SESSION_STORAGE__USER_INFO = 'xxxaaaxxx111'
export const SESSION_STORAGE__USER_INFO_12 = 'xxxaasaaxxx111'
export const SESSION_STORAGE__TOKEN = 'abssdsdsd'